<template>
  <div>
    <div
      style="display: flex; flex-direction: column; gap: 12px; padding: 32px"
    >
      <div
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        "
      >
        {{ $t("i18n_Cost") }}
      </div>
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          column-gap: 8px;
        "
      >
        <div class="bg-purple">
          <span
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            "
          >
            {{ $t("i18n_cost_generated_time") }}
          </span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="value1"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('i18n_started_date')"
            :end-placeholder="$t('i18n_end_date')"
          >
          </el-date-picker>
        </div>
        <div
          class="bg-purple normal"
          style="display: flex; align-items: center"
        >
          <span
            style="
              width: 56px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            "
          >
            {{ $t("i18n_Tracking_number") }}
          </span>
          <el-input
            :placeholder="$t('i18n_please_enter')"
            v-model="nos"
            clearable
          >
          </el-input>
        </div>
        <div
          class="bg-purple normal"
          style="display: flex; align-items: center"
        >
          <span
            style="
              width: 76px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            "
          >
            {{ $t("i18n_Clients_tracking_number") }}
          </span>
          <el-input
            :placeholder="$t('i18n_please_enter')"
            v-model="customerNo"
            clearable
          >
          </el-input>
        </div>
        <div class="bg-purple normal">
          <span
            style="
              width: 76px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            "
          >
            {{ $t("i18n_bill_status") }}
          </span>
          <el-select v-model="state" :placeholder="$t('i18n_please_choose')">
            <el-option
              v-for="item in statusList"
              :key="item.state"
              :label="$t(item.name)"
              :value="item.state"
            >
            </el-option>
          </el-select>

          <el-button
            @click="getListByParams(1)"
            style="
              width: 72px;
              height: 32px;
              line-height: 32px;
              margin-left: 20px;
              padding: 0px;
            "
            type="primary"
            >{{ $t("i18n_Inquiry") }}</el-button
          >
        </div>
      </div>
      <el-button
        @click="toPay()"
        style="width: 92px; height: 32px; line-height: 32px; padding: 0px"
        type="primary"
        >{{ $t("i18n_combine_payments") }}</el-button
      >
      <div>
        <!-- table -->
        <div style="max-height: 500px; overflow: auto">
          <table
            class="basic-table"
            style="width: 100%; border: 1px solid #e7e7e7"
          >
            <thead>
              <tr
                style="
                  background-color: #e7e7e7;
                  height: 35px;
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #9a9a9a;
                "
              >
                <th style="width: 50px; border: 1px solid #e7e7e7">
                  <!-- 全列表全选 -->
                  <el-checkbox
                    v-model="allSelectValue"
                    @change="allSelected($event)"
                  />
                </th>
                <th style="width: 50px">{{ $t("i18n_Serial_number") }}</th>
                <th v-for="(item, index) in title" :key="index">
                  {{ $t(item) }}
                </th>
              </tr>
            </thead>
            <tbody style="text-align: center" v-if="list.length > 0">
              <tr
                style="min-height: 40px; border: 1px solid #e7e7e7"
                v-for="(listItem, listIndex) in list"
                :key="listIndex"
              >
                <td class="tableBorderMy" style="width: 50px">
                  <!-- 全选 -->
                  <el-checkbox
                    v-if="listItem.show"
                    :value="listItem.checked"
                    @change="allSelectedChange($event, listIndex)"
                  />
                </td>
                <td class="tableBorderMy">{{ listIndex + 1 }}</td>
                <!-- 单号 -->
                <td class="tableBorderMy">{{ listItem.nos }}</td>
                <td class="tableBorderMy">{{ listItem.customerNo }}</td>
                <!-- 名称 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      )
                    }"
                  >
                    <!-- 单个选择 -->
                    <div style="display: flex; justify-content: center">
                      <!-- 最外居中内容 -->
                      <div style="display: flex; text-align: start">
                        <!-- 给俩个div固定宽度 -->
                        <div style="width: 16px; margin-right: 7px">
                          <el-checkbox
                            v-if="singleItem.status == 1"
                            v-model="singleItem.checked"
                            @change="
                              itemSelect(
                                $event,
                                listIndex,
                                itemIndex,
                                singleItem.id,
                                singleItem.cnyAmount
                              )
                            "
                          />
                        </div>
                        <div
                          style="
                            width: 120px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                          "
                        >
                          <span> {{ singleItem.feeName }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- 判断是否留border-bottom -->
                    <!-- !(listItem.detailList.length - 1 == itemIndex) -->
                  </div>
                </td>
                <!-- 金额 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      )
                    }"
                  >
                    {{ singleItem.amount }} {{ singleItem.currency }}
                  </div>
                </td>
                <!-- 时间 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      )
                    }"
                  >
                    {{ singleItem.inputtime }}
                  </div>
                </td>
                <!-- 账单状态 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      )
                    }"
                  >
                    <span v-if="singleItem.status == '1'">{{
                      $t("i18n_waiting_for_payment")
                    }}</span>
                    <span v-if="singleItem.status == '2'">{{
                      $t("i18n_waiting_for_confirmation")
                    }}</span>
                    <span v-if="singleItem.status == '3'">{{
                      $t("i18n_completed")
                    }}</span>
                    <span v-if="singleItem.status == '4'">{{
                      $t("i18n_payment_processing")
                    }}</span>
                  </div>
                </td>
                <!-- 操作 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      display: flex;
                      justify-content: center;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      )
                    }"
                  >
                    <span
                      style="color: #9a9a9a"
                      v-if="singleItem.feeName"
                      class="myCursor"
                      @click="getDetail(listIndex)"
                      >{{ $t("i18n_fee_details") }}</span
                    >
                    <div style="width: 30px">
                      <div
                        v-if="singleItem.status == 1"
                        class="myCursor paySpan"
                        @click="toPay(singleItem.id, '1', singleItem.cnyAmount)"
                      >
                        {{ $t("i18n_pay") }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="list.length == 0"
            style="
              line-height: 100px;
              height: 100px;
              width: 100%;
              color: #999;
              text-align: center;
            "
          >
            {{ $t("i18n_No_data") }}
          </div>
          <!-- 详情 -->
          <el-dialog
            class="Mydialog"
            :title="$t('i18n_fee_details')"
            :visible.sync="dialogVisible"
            width="30%"
            center
          >
            <div style="display: flex">
              <el-table
                :data="detail"
                :header-cell-style="{
                  background: '#eef1f6',
                  color: '#606266'
                }"
                border
                align="center"
                highlight-current-row
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column
                  align="center"
                  prop="feeName"
                  :label="$t('i18n_Charge_category')"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="amount"
                  :label="$t('i18n_Price')"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.TotalCnyAmount">
                      {{ scope.row.TotalCnyAmount }} CNY
                    </span>
                    <span v-else-if="scope.row.TotalCnyAmount1">
                      {{ scope.row.TotalCnyAmount1 }}
                    </span>
                    <span v-else>
                      {{ scope.row.currency }} {{ scope.row.price }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="amount2"
                  :label="$t('i18n_fee_details')"
                >
                  <template slot-scope="scope">
                    {{ scope.row.price }} {{ scope.row.currency }} *
                    {{ scope.row.piece }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-dialog>
        </div>
        <!-- table end -->
        <el-pagination
          style="margin-top: 20px; float: left"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // table
      totalAmount: [],
      detail: [],
      subListId: [],
      allSelect: false,
      title: [
        "i18n_Tracking_number",
        "i18n_Clients_tracking_number",
        "i18n_Fee_Name",
        "i18n_Amount_receivable",
        "i18n_cost_generated_time",
        "i18n_bill_status",
        "i18n_Operation",
      ],
      list: [],
      selectedByIndex: [],
      arrayIdSummary: [],
      dialogVisible: false,

      // table end
      payList: [],
      prefix: "",
      beginTime: "",
      tableData: [],
      multipleSelection: [],
      billBeginTime: "",
      billEndTime: "",
      billNo: "",
      state: "",
      statusList: [
        {
          name: "i18n_All",
          state: "0",
        },
        {
          name: "i18n_waiting_for_payment",
          state: "1",
        },
        {
          name: "i18n_waiting_for_confirmation",
          state: "2",
        },
        {
          name: "i18n_completed",
          state: "3",
        },
        {
          name: "i18n_payment_processing",
          state: "4",
        },
      ],
      value1: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      billBeginTime: "",
      billEndTime: "",
      nos: "",
      customerNo: '',
      state: "0",
    };
  },
  watch: {},
  methods: {
    // table
    getDetail(parentIndex) {
      // console.log(parentIndex);

      this.axios
        .post("/arap/getFinaArapWebDetailList", {
          beginTime: "",
          endTime: "",
          id: this.list[parentIndex].id,
          status: "",
        })
        .then((res) => {
          if (res.data.code == 200) {
            // 费用
            // 获取包含币种名称
            let C = [];
            res.data.datas.forEach((i, index) => {
              if (C.indexOf(i.currency) == -1) {
                C.push(i.currency);
              }
            });
            // 获取包含币种的金额数
            let nums = [];
            let tempList = res.data.datas;
            for (let index = 0; index < C.length; index++) {
              let yesNum = [];
              for (let index2 = 0; index2 < tempList.length; index2++) {
                if (tempList[index2].currency == C[index]) {
                  // 可能会有null或空字符串的情况
                  if (
                    tempList[index2].price == null ||
                    tempList[index2].price == ""
                  ) {
                    yesNum.push(parseFloat(0));
                  } else {
                    yesNum.push(parseFloat(tempList[index2].price));
                  }
                }
              }

              nums.push(yesNum);
            }
            // 计算出个币种的总金额

            let finalCurrency = "";

            C.forEach((i, index) => {
              //  拼接字符串
              let finalNum = nums[index].reduce((prev, cur) => prev + cur);

              finalCurrency +=
                C[index] +
                " " +
                parseFloat(finalNum).toFixed(2) +
                " " +
                "+" +
                " ";
            });
            finalCurrency = finalCurrency.substr(0, finalCurrency.length - 2);

            // 折合人民币
            let TotalCnyAmount = 0;
            // debugger;
            res.data.datas.forEach((i) => {
              TotalCnyAmount += parseFloat(i.cnyAmount);
            });
            let temp = [
              { feeName: this.$t("i18n_Total_payment"), TotalCnyAmount1: finalCurrency },
              { feeName: this.$t("i18n_Covert_to_CNY"), TotalCnyAmount: parseFloat(TotalCnyAmount).toFixed(2) },
            ];

            this.detail = [...res.data.datas, ...temp];
            this.dialogVisible = true;
            return;
          }
          this.$message.info(res.data.message);
        })
        .catch(res => { });
    },
    // 全选
    allSelected(e) {
      // console.log(e);
      if (e) {
        this.list.forEach((i, index) => {
          this.list[index].checked = true;
          // 改变child下面的checkd
          let temp = [];
          let ids = [];

          //  二级for
          this.list[index].detailList.forEach((item, index2) => {
            // item.checked = true;
            temp.push(item);
            // console.log(index2)
            // 已经在computed实现 
            // 只有待支付才计入id数组
            if (item.status == 1) {
              // 只有待支付才true 不然取消勾选 全选行  还是显示勾选
              item.checked = true;
              ids.push(item.id);
              // 总额数组 方便删除 拿到index即可 
              this.totalAmount[index].push({ id: item.id, money: item.cnyAmount });
              // this.totalAmount[index].push({ id: item.id, money: item.amount });
              // 
            }
          });
          this.arrayIdSummary[index] = ids;
          // 子集改变状态
          this.list[index].detailList = temp;
          this.$set(this.list, index, this.list[index]);
        });

        return;
      } else {
        this.list.forEach((i, index) => {
          this.list[index].checked = false;
          // 改变child下面的checkd
          let temp = [];
          //  二级for
          this.list[index].detailList.forEach((item) => {
            item.checked = false;
            temp.push(item);
          });
          // 子集改变状态
          this.list[index].detailList = temp;
          this.$set(this.list, index, this.list[index]);
          this.arrayIdSummary[index] = [];
          this.totalAmount[index] = [];
        });
      }
    },
    // 单个对象选择
    allSelectedChange(event, index) {
      // 第一个改变状态
      this.list[index].checked = event;
      let temp = [];
      // 添加id
      // 如果true
      if (event) {
        // 放入id数组集合方便后续删除
        let temId = [];
        this.list[index].detailList.forEach((i, index2) => {
          // 只有待支付才能选中
          if (i.status == 1) {
            // 总金额计算
            this.totalAmount[index].push({ id: i.id, money: i.cnyAmount });
            // 计入id
            temId.push(this.list[index].detailList[index2].id);
          }

          this.arrayIdSummary[index] = temId;
        });
        // 去重
        this.subListId = [...new Set(this.subListId)];
      } else {
        this.totalAmount[index] = [];
        this.arrayIdSummary[index] = [];
      }

      this.list[index].detailList.forEach((item) => {
        if (item.status == 1) {
          item.checked = event;

        }
        temp.push(item);

      });
      // 子集改变状态
      this.list[index].detailList = temp;
      this.$set(this.list, index, this.list[index]);
      // console.log(this.allSelectValue);
    },
    // 运单号下children单个选择
    itemSelect(e, parentIndex, childIndex, id, money) {
      // debugger
      // true就加入
      // console.log(this.arrayIdSummary[parentIndex].indexOf(id));
      if (e) {
        // 没此id就push
        // debugger
        if (this.arrayIdSummary[parentIndex].indexOf(id) == -1) {
          this.arrayIdSummary[parentIndex].push(id);
          this.totalAmount[parentIndex].push({ id: id, money: money });
        }
      } else {
        this.arrayIdSummary[parentIndex].forEach((idItem, idsIndex) => {
          if (idItem == id) {
            this.totalAmount[parentIndex].splice(idsIndex, 1);
            this.arrayIdSummary[parentIndex].splice(idsIndex, 1);
          }
        });
      }
      let temp = [];
      // 获取list里的detailist的check进行更改 后 set
      this.list[parentIndex].detailList[childIndex].checked = e;
      // 更新渲染
      this.$set(this.list, parentIndex, this.list[parentIndex]);
      let flag = false;
      // 判断detail里是否有true 有的话 父级为true
      this.list[parentIndex].detailList.forEach((i) => {
        if (i.checked) {
          flag = true;
        } else {

        }
      });
      // 运单号下children单个选中了 则勾选father的checkd
      this.list[parentIndex].checked = flag;
      // 更新渲染
      this.$set(this.list, parentIndex, this.list[parentIndex]);
      // console.log(parentIndex)
      // console.log(id)
      // console.log(e)
    },
    // table end

    handleCheckAllChange(val) {
      console.log(this.tableData);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListByParams();
    },
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val;
      this.getListByParams();
    },
    // 根据参数查询
    getListByParams(type) {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      let param = {
        beginTime: "",
        endTime: "",
        nos: "",
        customerNo: '',
        curPage: this.currentPage,
        customerId: user.customerid,
        pageSize: this.pageSize,
        startIndex: 0,
        status: "",
      };
      console.log(param)
      if (type == 1) {
        param.curPage = 1;
      }
      if (this.value1 == null) {
      } else {
        if (this.value1.length > 1) {
          param.beginTime = this.value1[0];
          param.endTime = this.value1[1];
        }
      }

      if (this.nos) {
        param.nos = this.nos;
      }
      if (this.customerNo) {
        param.customerNo = this.customerNo;
      }
      if (this.state) {
        if (this.state == 0) {
          param.status = "";
        } else {
          param.status = this.state;
        }
      }

      this.axios
        .post("/arap/getFinaArapWebList", param)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.datalList.length > 0) {
              this.list = res.data.data.datalList;
              this.total = res.data.data.totalCounts;
              // 清空，不然每次都会叠加
              this.arrayIdSummary = [];
              this.totalAmount = [];

              this.list.forEach((i) => {
                i.checked = false;
                // 初始化id数组
                this.arrayIdSummary.push([]);
                this.totalAmount.push([]);
                i.detailList.forEach((i2) => {
                  i2.checked = false;

                });
                let reslut1 = i.detailList.some(v => {
                  return v.status == 1
                })
                if (reslut1) {
                  i.show = true
                } else {
                  i.show = false
                }
              });

              return;
            }
            this.$message.info("无相关记录");
            this.list = [];
            this.total = res.data.data.totalCounts;
            // 清空，不然每次都会叠加
            this.arrayIdSummary = [];
            this.totalAmount = [];
            return;
          }
          this.$message.info(res.data.message);
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取账单列表
    getList() {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);

      this.axios
        .post("/arap/getFinaArapWebList", {
          beginTime: "",
          curPage: 1,
          customerId: user.customerid,
          endTime: "",
          nos: "",
          pageSize: 10,
          startIndex: 0,
          status: "",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.list = res.data.data.datalList;
            this.total = res.data.data.totalCounts;

            this.list.forEach((i) => {
              i.checked = false;
              // 初始化id数组
              this.arrayIdSummary.push([]);
              this.totalAmount.push([]);
              i.detailList.forEach((i2) => {
                i2.checked = false;

              });
              let reslut1 = i.detailList.some(v => {
                return v.status == 1
              })
              if (reslut1) {
                i.show = true
              } else {
                i.show = false
              }
            });

            return;
          }
          this.$message.info(res.data.message);
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 去支付页面
    toPay(id, type, amount) {
      // 单个支付
      if (type == 1) {
        this.$router.push({
          name: "payOrder",
          params: {
            id,
            amount,
          },
        });
        return;
      }

      // 多个支付
      let temId = [];
      this.arrayIdSummary.forEach((item) => {
        item.forEach((item2) => {
          temId.push(item2);
        });
      });
      let totalMoney = 0;

      this.totalAmount.forEach((item) => {
        item.forEach((item2) => {
          totalMoney += parseFloat(item2.money);
        });
      });
      console.log(totalMoney.toFixed(2));
      if (!temId.length > 0) {
        this.$message.info("请选择最少一个费用");
        return;
      }
      // 去重
      temId = [... new Set(temId)]
      this.$router.push({
        name: "payOrder",
        params: {
          temId,
          amount: totalMoney.toFixed(2),
        },
      });

      // console.log(id)
      //  this.$router.push("/index/Personalindex/tabelTest");
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val);
    },
  },
  computed: {
    allSelectValue: {
      get() {

        let flag;
        // 先过滤出，show等于true的数据，然后遍历
        //  这个判断因为vue初始化时list的数据还没回来
        if (this.list.length > 0) {
          console.log(12)
          let tempArray = this.list.filter(v => {
            return v.show == true
          })
          //  for
          for (let index = 0; index < tempArray.length; index++) {

            if (!tempArray[index].checked) {
              flag = false;
              //  如果全选 添加所有id
              // this.list.forEach((i) => {
              //   i.detailList.forEach((item) => {
              //     // this.subListId.push(item.id);
              //   });
              // });
              break;
            } else {
              flag = true;
              // this.subListId = [];
              break;
            }
          }
          //  for end 

        } else {
          console.log(13)
          for (let index = 0; index < this.list.length; index++) {

            if (this.list[index].checked) {
              flag = true;
              //  如果全选 添加所有id
              this.list.forEach((i) => {
                i.detailList.forEach((item) => {
                  // this.subListId.push(item.id);
                });
              });
              break;
            } else {
              flag = false;
              // this.subListId = [];
              break;
            }
          }
        }



        return flag;
      },

      set(val) {
        // this.wordData = val;
      },
    },

    // allSelectValue() {

    //   let flag;

    //   for (let index = 0; index < this.list.length; index++) {
    //     if (this.list[index].checked) {
    //       flag = true;
    //       //  如果全选 添加所有id
    //       this.list.forEach((i) => {
    //         i.detailList.forEach((item) => {
    //           // this.subListId.push(item.id);
    //         });
    //       });
    //       break;
    //     } else {
    //       flag = false;
    //       // this.subListId = [];
    //       break;
    //     }
    //   }

    //   return flag;
    // },
  },
  created() { },

  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.paySpan {
  color: $d2d-color-primary;
  margin-left: 20px;
  width: 30px;
}
/deep/ .el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 0px 25px 30px;
}

/deep/ .bg-purple .el-input__inner {
  width: 262px;
  height: 32px;
  line-height: 32px;
}

/deep/ .normal .el-input__inner {
  width: 216px;
  height: 32px;
  line-height: 32px;
}

/* .itemsStyle {
  border-bottom: solid 1px #eee;
  padding:8px 0
}
.itemsStyleNo {
  padding:8px 0
} */

.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
.myCursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/Mybill.vue